/**
 * Route definitions for the API credentials section (credentials list,
 * create credential, and filter drawer).
 * Mirrors the pattern in views/admin/dashboard-users/routes.tsx.
 */
import { RouteObject } from "react-router-dom";
import { GraphQL } from "@rpi/openapi-api";
import { featureFlags } from "../../featureFlags";
import { withHandle } from "../../utils/route.util";
import { ApiCredentialCreateView } from "./ApiCredentialCreateView";
import { ApiCredentialsView } from "./ApiCredentialsView";
import { ApiCredentialsFilterInner, path as apiCredentialsFilterPath } from "./ApiCredentialsFilter";

export const apiCredentialsFilterRoute: RouteObject = {
  path: apiCredentialsFilterPath,
  element: <ApiCredentialsFilterInner />,
  ...withHandle("api-credentials-filter", {
    requiredRole: GraphQL.DashboardUserRole.SuperAdmin,
  }),
};

export const apiCredentialsRoutes: RouteObject[] = [
  {
    path: "api-credentials",
    element: <ApiCredentialsView />,
    ...withHandle("api-credentials"),
    children: [
      ...(featureFlags.newSearchExperience ? [apiCredentialsFilterRoute] : []),
      {
        path: "create",
        ...withHandle("api-credential-create", {
          requiredRole: [GraphQL.DashboardUserRole.CustomerAdmin, GraphQL.DashboardUserRole.User],
        }),
        element: <ApiCredentialCreateView />,
      },
    ],
  },
];
